<div
  class="content-module references-module"
  [attr.data-show-references]="showReferences"
>
  <h4
    class="references__title"
    (click)="toggleReferences()"
  >
    {{'Common.Library.Modules.references_title'|translate}}
    <span class="references__title-icon icon icon-arrow-sm"></span>
  </h4>

  <div class="references__inner" *ngIf="showReferences" [@toggleReferences]>
    <ng-container *ngIf="references.texts">
      <div
        *ngFor="let reference of references.texts"
        [innerHTML]="reference.text"
        class="reference__text cms-content"
      ></div>
    </ng-container>

    <ul class="references__links list--links" *ngIf="references.links">
      <li class="links__item" *ngFor="let link of references.links">
        <a
          *ngIf="link.typeLink === 'internal'"
          [routerLink]="link.url"
          class="links__link"
        >
          {{ link.text }}
        </a>
        <a
          *ngIf="link.typeLink === 'external'"
          [href]="link.url"
          target="_blank"
          class="links__link"
        >
          {{ link.text }}
        </a>
      </li>
    </ul>
  </div>
</div>
